module.exports = __webpack_public_path__ + "static/media/triangluar-top-arrow.da3d1540.svg";